import React, { useState, useEffect } from "react";
import Footer from "../../footer";
import AdminSidebar from "../sidebar";
import { getIdData, addData, updateData } from "../../../lib/lessons"
import { useNavigate, useParams } from 'react-router-dom';
import {ClassForLessonSelect} from "../../ui/myselect";

export default function AdminLessonsEdit() {

  const [classforLesson, setClassForLesson] = useState(9);
  const [lessonname, setLessonName] = useState();
  const [isActive, setIsActive] = useState(true);
  const [data, setData] = useState([]);
  const [category, setCategory] = useState(null);
  const [defCategory, setDefCategory] = useState(0);
  const [options, setOptions] = useState([]);
  const [catName, setCatName] = useState();

  const navigate = useNavigate();
  let { slug ,cat } = useParams();


  async function GetData(id) {

    //data
    const lessonnameData = await getIdData(slug);
    console.log("parameterData", lessonnameData[0]);
    setData(lessonnameData);
    setLessonName(lessonnameData[0].lessonname);
    setIsActive(lessonnameData[0].isActive);
    setClassForLesson(lessonnameData[0].class);

//isDisabled = {slug === "Add" ? false : true}
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (slug === "Add") {
      await addData({
        class : classforLesson,
        lessonname: lessonname,
        isActive: isActive
      });
  
    }
    else {
      console.log("Update");
      await updateData({
        id: slug,
        class:classforLesson,
        lessonname: lessonname,
        isActive: isActive
      });
    }

    navigate("/admin/admin-lessons");
  };

  useEffect(() => {
    if (slug !== "Add") {
      GetData(slug);
    }

  }, [slug])
  return (
            <div className="col-xl-9 col-md-8">
              <div className="settings-widget profile-details">
                <div className="settings-menu p-0">
                  <div className="profile-heading">
                    <h3>{slug === "Add" ? "Add AppCheck" : "Update AppCheck"}</h3>
                  </div>
                  <div className="checkout-form personal-address add-course-info ">
                    <form role="form" onSubmit={handleSubmit}>
                      <div className="row mx-auto">
                      <div className="col-9">
                          <div className="form-group w-50">
                          <label className="form-control-label">
                              Class
                            </label>
                            <ClassForLessonSelect value={classforLesson}  setValue = {setClassForLesson} name={"ClassForLessonSelect"} />
                          </div>
                        </div>
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Lesson Name
                            </label>
                            <input
                              type="text"
                              value={lessonname}
                              onChange={(e) => setLessonName(e.target.value)}
                              className="form-control"
                              placeholder="Enter lessonname"
                              required
                            />
                          </div>
                        </div>

                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Is Active
                            </label>
                            <div className="form-check form-switch check-on">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isActive}
                                onChange={(e) => setIsActive(!isActive)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="update-profile d-flex justify-content-between">
                          <button type="submit" className="btn btn-primary">
                            {slug === "Add" ? "Add Lesson" : "Update Lesson"}
                          </button>
                          <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                            Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
  );
}
